// extracted by mini-css-extract-plugin
export var bodySections = "_3r-8";
export var gray = "_3r-7";
export var green = "_3r-4";
export var iconContainer = "_3r-9";
export var iconWidgetContainer = "_3r-1";
export var phoneIcon = "_3r-2";
export var red = "_3r-5";
export var statusDot = "_3r-3";
export var widgetContainer = "_3r-0";
export var yellow = "_3r-6";